export default __webpack_public_path__ + "static/award-2013-2941491b1c93c67ca25150f9f69a2252.jpg";